if (!customElements.get('c-cookie-consent')) {
  customElements.define(
    'c-cookie-consent',
    class CookieConsent extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
      }

      connectedCallback() {
        this.banner = this.querySelector('.c_c-footer-cookie-banner');
        this.dialog = this.querySelector('.c_c-footer-cookie-banner__dialog');
        this.addEventListener('click', this.onClick);
        // Cookie ポリシーのページの設定ボタンはこの要素の外にあるため、document で受ける
        document.addEventListener('click', this.onDocumentClick);

        window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          if (!error) this.setup();
        });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('click', this.onDocumentClick);
      }

      setup() {
        this.syncCheckboxes();
        // API が使えるまでは押しても記録できないため、ボタンを無効にしておく
        this.querySelectorAll('[data-cookie-action]').forEach((button) => {
          button.disabled = false;
        });
        if (window.Shopify.customerPrivacy.shouldShowBanner() || window.Shopify.designMode) {
          this.banner.hidden = false;
        }
      }

      syncCheckboxes() {
        const consent = window.Shopify.customerPrivacy.currentVisitorConsent();
        this.dialog.querySelectorAll('[data-consent]').forEach((input) => {
          input.checked = consent[input.dataset.consent] === 'yes';
        });
      }

      onClick(event) {
        if (event.target.closest('.c_js-cookie-settings-close')) {
          this.dialog.close();
          return;
        }
        if (event.target === this.dialog) {
          this.dialog.close();
          return;
        }
        const action = event.target.closest('[data-cookie-action]')?.dataset.cookieAction;
        if (!action || !window.Shopify?.customerPrivacy) return;

        const consent = {};
        this.dialog.querySelectorAll('[data-consent]').forEach((input) => {
          consent[input.dataset.consent] = action === 'save' ? input.checked : action === 'accept';
        });
        this.saveConsent(consent);
      }

      onDocumentClick(event) {
        if (!event.target.closest('.c_js-cookie-settings-open') || !window.Shopify?.customerPrivacy) return;
        this.syncCheckboxes();
        this.dialog.showModal();
      }

      saveConsent(consent) {
        window.Shopify.customerPrivacy.setTrackingConsent(consent, () => {
          if (this.dialog.open) this.dialog.close();
          if (!this.banner.hidden) {
            // 押したボタンごとバナーを隠すとフォーカスが失われるため、main へ移す
            const hadFocus = this.banner.contains(document.activeElement);
            this.banner.hidden = true;
            if (hadFocus) document.getElementById('MainContent')?.focus({ preventScroll: true });
          }
          this.syncCheckboxes();
        });
      }
    }
  );
}
